import { IContractsFilter } from './types'

import { Button, Container, Divider, Drawer, Empty, Flex, Input, Toogle, ToolTip } from "@ui/index"

import imgEmty from '@img/empty.svg'
import { IconClearClose, IconDateEdit } from "@img/icons"

import css from './ui.module.scss'



/** Фильтр договоров */
export const ContractsFilter = ({
    isOpen = false, handlerButtonCancel,
    filterSites,
    filterContractStatuses, handleApplyClearFilter,
    filterDateStartEducationFrom, filterDateStartEducationBefore,
    filterDateEndEducationFrom, filterDateEndEducationBefore,
    filterDateCreateFrom, filterDateCreateBefore, filterIsCompany,
    handleOpenModalCalendar
}: IContractsFilter) => {
    const handleSelectSites = (id: number) => {
        const updatedSites = filterSites.value.map(site => {
            if (site.id === id) {
                return { ...site, isSelected: !site.isSelected }
            }

            return site
        })

        filterSites.setValue(updatedSites)
    }

    const handleSelectStatus = (id: number) => {
        const updatedStatuses = filterContractStatuses.value.map(status => {
            if (status.id === id) {
                return { ...status, isSelected: !status.isSelected }
            }

            return status
        })

        filterContractStatuses.setValue(updatedStatuses)
    }

    const handleClearSelection = () => {
        const updatedStatuses = filterContractStatuses.value.map(status => ({ ...status, isSelected: false }))
        filterContractStatuses.setValue(updatedStatuses)
    }

    return <>
        <Drawer isOpen={isOpen} zIndex={1001} isEsc isWrapper isWrapperBlur={false} onCancel={handlerButtonCancel} maxWidth='370px' placement='right'>
            <Flex className='drawer_container'>
                <Flex flexDirection='row' alignItems='center' justifyContent='space-between' className='drawer_container-header'>
                    <h4>Фильтр...</h4>

                    <Button variant='icon' size='sm' onClick={handlerButtonCancel}>
                        <IconClearClose width="20px" height="20px" />
                    </Button>
                </Flex>

                <Flex gap='4px' className='drawer_container-body'>
                    <Flex gap='20px' className='drawer_container-content'>
                        <Flex gap="4px">
                            <Divider prefix='Дата начала обучения' gap="6px"
                                suffix={(filterDateStartEducationFrom.value || filterDateStartEducationBefore.value) && 
                                    <ToolTip title='Очистить' placement="left">
                                        <Button size='xs' variant='icon' onClick={() => { 
                                            filterDateStartEducationFrom.setValue('')
                                            filterDateStartEducationBefore.setValue('') 
                                        }}><IconClearClose width='16px' height='16px' /></Button>
                                    </ToolTip>
                                } 
                            />

                            <Flex gap="2px" flexDirection="row">
                                <Input {...filterDateStartEducationFrom} 
                                    placeholder='Дата - старт' type='mask' mask='99.99.2099' maskChar="" 
                                    size='md' paddingRight='2px' width='100%' 
                                    maxLength={10}
                                    suffix={
                                        <Flex flexDirection="row">
                                            {filterDateStartEducationFrom.value &&
                                                <ToolTip title='Очистить' placement="left">
                                                    <Button size='xs' variant='iconInput' 
                                                        onClick={() => filterDateStartEducationFrom.setValue('')}
                                                    ><IconClearClose width='16px' height='16px' /></Button>
                                                </ToolTip>
                                            }
                                            
                                            <ToolTip title='Выбрать' placement="left">
                                                <Button size='xs' variant='iconInput'
                                                    onClick={() => handleOpenModalCalendar(true, 'dateStartEducationFrom')}
                                                ><IconDateEdit width='16px' height='16px' /></Button>
                                            </ToolTip>
                                        </Flex>
                                    }
                                />

                                <Input {...filterDateStartEducationBefore}
                                    placeholder='Дата - конец' type='mask' mask='99.99.2099' maskChar="" 
                                    size='md' paddingRight='2px' width='100%' 
                                    maxLength={10}
                                    suffix={
                                        <Flex flexDirection="row">
                                            {filterDateStartEducationBefore.value && 
                                                <ToolTip title='Очистить' placement="left">
                                                    <Button size='xs' variant='iconInput' 
                                                        onClick={() => filterDateStartEducationBefore.setValue('')}
                                                    ><IconClearClose width='16px' height='16px' /></Button>
                                                </ToolTip>
                                            }
                                            
                                            <ToolTip title='Выбрать' placement="left">
                                                <Button size='xs' variant='iconInput'
                                                    onClick={() => handleOpenModalCalendar(true, 'dateStartEducationBefore')}
                                                ><IconDateEdit width='16px' height='16px' /></Button>
                                            </ToolTip>
                                        </Flex>
                                    }
                                />
                            </Flex>
                        </Flex>

                        <Flex gap="4px">
                            <Divider prefix='Дата создания договора' gap="6px"
                                suffix={(filterDateCreateFrom.value || filterDateCreateBefore.value) && 
                                    <ToolTip title='Очистить' placement="left">
                                        <Button size='xs' variant='icon' onClick={() => { 
                                            filterDateCreateFrom.setValue('')
                                            filterDateCreateBefore.setValue('') 
                                        }}><IconClearClose width='16px' height='16px' /></Button>
                                    </ToolTip>
                                } 
                            />

                            <Flex gap="2px" flexDirection="row">
                                <Input {...filterDateCreateFrom}
                                    placeholder='Дата - старт' type='mask' mask='99.99.2099' maskChar="" 
                                    size='md' paddingRight='2px' width='100%' 
                                    maxLength={10}
                                    suffix={
                                        <Flex flexDirection="row">
                                            {filterDateCreateFrom.value && 
                                                <ToolTip title='Очистить' placement="left">
                                                    <Button size='xs' variant='iconInput' 
                                                        onClick={() => filterDateCreateFrom.setValue('')}
                                                    ><IconClearClose width='16px' height='16px' /></Button>
                                                </ToolTip>
                                            }
                                            
                                            <ToolTip title='Выбрать' placement="left">
                                                <Button size='xs' variant='iconInput'
                                                    onClick={() => handleOpenModalCalendar(true, 'dateCreateFrom')}
                                                ><IconDateEdit width='16px' height='16px' /></Button>
                                            </ToolTip>
                                        </Flex>
                                    }
                                />

                                <Input {...filterDateCreateBefore}
                                    placeholder='Дата - конец' type='mask' mask='99.99.2099' maskChar="" 
                                    size='md' paddingRight='2px' width='100%' 
                                    maxLength={10}
                                    suffix={
                                        <Flex flexDirection="row">
                                            {filterDateCreateBefore.value && 
                                                <ToolTip title='Очистить' placement="left">
                                                    <Button size='xs' variant='iconInput' 
                                                        onClick={() => filterDateCreateBefore.setValue('')}
                                                    ><IconClearClose width='16px' height='16px' /></Button>
                                                </ToolTip>
                                            }
                                            
                                            <ToolTip title='Выбрать' placement="left">
                                                <Button size='xs' variant='iconInput'
                                                    onClick={() => handleOpenModalCalendar(true, 'dateCreateBefore')}
                                                ><IconDateEdit width='16px' height='16px' /></Button>
                                            </ToolTip>
                                        </Flex>
                                    }
                                />
                            </Flex>
                        </Flex>

                        <Flex gap="4px">
                            <Divider prefix='Дата окончания обучения' gap="6px"
                                suffix={(filterDateEndEducationFrom.value || filterDateEndEducationBefore.value) &&
                                    <ToolTip title='Очистить' placement="left">
                                        <Button size='xs' variant='icon' onClick={() => {
                                            filterDateEndEducationFrom.setValue('')
                                            filterDateEndEducationBefore.setValue('')
                                        }}><IconClearClose width='16px' height='16px' /></Button>
                                    </ToolTip>
                                }
                            />

                            <Flex gap="2px" flexDirection="row">
                                <Input {...filterDateEndEducationFrom}
                                    placeholder='Дата - старт' type='mask' mask='99.99.2099' maskChar=""
                                    size='md' paddingRight='2px' width='100%'
                                    maxLength={10}
                                    suffix={
                                        <Flex flexDirection="row">
                                            {filterDateEndEducationFrom.value &&
                                                <ToolTip title='Очистить' placement="left">
                                                    <Button size='xs' variant='iconInput'
                                                        onClick={() => filterDateEndEducationFrom.setValue('')}
                                                    ><IconClearClose width='16px' height='16px' /></Button>
                                                </ToolTip>
                                            }

                                            <ToolTip title='Выбрать' placement="left">
                                                <Button size='xs' variant='iconInput'
                                                    onClick={() => handleOpenModalCalendar(true, 'dateEndEducationFrom')}
                                                ><IconDateEdit width='16px' height='16px' /></Button>
                                            </ToolTip>
                                        </Flex>
                                    }
                                />

                                <Input {...filterDateEndEducationBefore}
                                    placeholder='Дата - конец' type='mask' mask='99.99.2099' maskChar=""
                                    size='md' paddingRight='2px' width='100%'
                                    maxLength={10}
                                    suffix={
                                        <Flex flexDirection="row">
                                            {filterDateEndEducationBefore.value &&
                                                <ToolTip title='Очистить' placement="left">
                                                    <Button size='xs' variant='iconInput'
                                                        onClick={() => filterDateEndEducationBefore.setValue('')}
                                                    ><IconClearClose width='16px' height='16px' /></Button>
                                                </ToolTip>
                                            }

                                            <ToolTip title='Выбрать' placement="left">
                                                <Button size='xs' variant='iconInput'
                                                    onClick={() => handleOpenModalCalendar(true, 'dateEndEducationBefore')}
                                                ><IconDateEdit width='16px' height='16px' /></Button>
                                            </ToolTip>
                                        </Flex>
                                    }
                                />
                            </Flex>
                        </Flex>

                        <Flex gap="4px">
                            <Divider prefix='Статус договора' gap="6px" suffix={
                                filterContractStatuses.value.filter((item) => item.isSelected === true).length > 0 && 
                                    <ToolTip title='Очистить' placement="left">
                                        <Button size='xs' variant='icon' onClick={handleClearSelection}>
                                            <IconClearClose width='16px' height='16px' />
                                        </Button>
                                    </ToolTip>
                                } 
                            />

                            <Flex gap="4px">
                                {filterContractStatuses.value.length === 0
                                    ? <Empty image={imgEmty} title="Данные отсутствуют" size='100px' /> 
                                    : filterContractStatuses.value.map((item) => {
                                        return (
                                            <Container key={item.id} padding="4px 3px 4px 10px" className={css['filter_toogle_container']}>
                                                <p>{item.name}:</p>
                                                <Toogle checked={item.isSelected} onChange={() => handleSelectStatus(item.id)} />
                                            </Container>
                                        )
                                    })
                                }
                            </Flex>
                        </Flex>

                        <Flex gap="4px">
                            <Divider prefix='Отобразить договоры сайта' gap="6px" />

                            <Flex gap="4px">
                                {filterSites.value.map((item) => {
                                    return (
                                        <Container key={item.id} padding="4px 3px 4px 10px" className={css['filter_toogle_container']}>
                                            <p>{item.description}:</p>
                                            <Toogle checked={item.isSelected} onChange={() => handleSelectSites(item.id)} />
                                        </Container>
                                    )
                                })}
                            </Flex>
                        </Flex>

                        <Flex gap="4px">
                            <Divider prefix='Прочее' gap="6px" />

                            <Flex gap="4px">
                                <Container padding="4px 3px 4px 10px" className={css['filter_toogle_container']}>
                                    <p>Только юридические лица:</p>
                                    <Toogle checked={filterIsCompany.value} onChange={() => filterIsCompany.setValue(!filterIsCompany.value)} />
                                </Container>
                            </Flex>
                        </Flex>
                    </Flex>

                    <div style={{gap: '5px', display: 'grid', gridTemplateColumns: '1fr 1fr'}}>
                        <Button variant="primaryDark" onClick={() => handleApplyClearFilter('clear')}>Очистить</Button>
                        <Button onClick={() => handleApplyClearFilter('apply')}>Применить</Button>
                    </div>
                </Flex>
            </Flex>
        </Drawer>
    </>
}